const { id, log, round, getDropdownType } = require("../std/index")


// Const

const ANIMAL_HOG = 'Hog';
const ANIMAL_BEEF = 'Beef';
const ANIMAL_SHEEP = 'Sheep';
const SYNTH_COLLAGEN = 'Collagen';
const SYNTH_FIBROUS = 'Fibrous';
const SYNTH_PLASTIC = 'Plastic';

const ANIMAL_UNKNOWN = 'Unknown';

const HANK_LENGTH = 90;


// Helpers

const rxDiameter = /\d\d(-\d\d|\+)/;

const perSausageWeight = (animal) => {
  return animal === ANIMAL_HOG ? 0.12 : 0.1;
};

const decomposeProductName = (product) => {
  if (rxDiameter.test(product)) {
    const diam = product.match(rxDiameter);
    const title = product.replace(' ' + diam, "");
    const animal = title.replace(' Casing', "");
    return [animal, diam];
  } else {
    return ["Unknown", 0];
  }
};

const detectAnimal = (product) => {
  if (/hog/i.test(product)) return ANIMAL_HOG;
  if (/sheep/i.test(product)) return ANIMAL_SHEEP;
  if (/beef/i.test(product)) return ANIMAL_BEEF;
  if (/collagen/i.test(product)) return SYNTH_COLLAGEN;
  if (/fibrous/i.test(product)) return SYNTH_FIBROUS;
  if (/barrier/i.test(product)) return SYNTH_PLASTIC;
  return ANIMAL_UNKNOWN;
};

const findLengthRelatedDropdowns = ($dropdowns) => {
  for (const keyword of ['length', 'size', 'pieces']) {
    const $matches = $dropdowns.filter('[data-input="' + keyword + '"]');
    if ($matches.length) {
      return $matches;
    }
  }
  return $();
};


//
// Sausage Calculator Widget
//

module.exports = class SausageCalculatorWidget {
  constructor($host, config) {
    this.config = config;

    this.dom = {
      dropdown: findLengthRelatedDropdowns($('select[data-input]', $host)),
      output: {
        capacity: $('[data-output="capacity"]'),
        sausages: $('[data-output="sausages"]')
      }
    };

    this.state = {
      animal: detectAnimal(this.config.product),
      selected: {},
      hankWeight: this.determineHank(this.config),
      meterLength: 0
    };

    this.callbacks = {
      change: id
    };

    // Early out: no length dropdown to use for calculations
    if (!this.dom.dropdown.length) {
      this.hideCalculatorInterface();
      return;
    }

    // Listeners
    this.dom.dropdown.on('change', this.onEitherDropdownChange.bind(this));

    // Init
    this.dom.dropdown.trigger('change');
    this.updateOutput();

    this.log('detect-animal', this.config.product, '-=>', this.state.animal);
    this.log('init', this.dom.dropdown);
  }

  determineHank(config) {
    if (config.hank) {
      return parseInt(config.hank, 10);
    }

    if (config.tags) {
      const tags = config.tags.split(' ');
      for (const tag of tags) {
        if (tag.match(/\d+kg/)) {
          return parseInt(tag, 10);
        }
      }
    }

    return 0;
  }

  onEitherDropdownChange({ target }) {
    const type = getDropdownType(target);
    const $option = $(target).find(':selected');
    if (type === 'length') this.state.meterLength = parseInt($option.text());
    this.state.selected[type] = $option;
    this.callbacks.change(type, this.state.selected);
    this.updateOutput();
  }

  report(fill, num) {
    const str = [this.state.meterLength + 'm', "of",
      this.state.animal, "casings with a",
      this.state.hankWeight + 'kg', "hank weight holds",
      (round(fill)) + "kg,", "making", num, "sausages"];
    this.log('report', ...str);
  }

  updateOutput() {
    const fillWeight = this.state.hankWeight * this.state.meterLength / HANK_LENGTH;
    const sausages = round(fillWeight / perSausageWeight(this.state.animal));
    this.report(fillWeight, sausages);
    this.dom.output.capacity.text((round(fillWeight)) + 'KG');
    this.dom.output.sausages.text(sausages);
  }

  hideCalculatorInterface() {
    this.dom.output.hide();
    this.dom.sausages.hide();
  }

  // External hooks

  onDropdownChange(λ) {
    this.callbacks.change = λ;
  }

  // Misc

  log(method, ...args) {
    log.apply(null, ["SausageCalculator::" + method + " -"].concat(args));
  }
};
